import { useState } from 'react';
import { Link, useOutletContext } from 'react-router-dom';
import { useDashboardContext } from '../contexts/DashboardContext';
import { useAnalytics } from '../hooks/useAnalytics';
import AnalyticsKPI from '../components/analytics/AnalyticsKPI';
import TrendsChart from '../components/analytics/TrendsChart';
import AlbumsPerformance from '../components/analytics/AlbumsPerformance';
import { DashboardHeader } from '../components/dna/DashboardHeader';

const Analytics = () => {
  const { toggleMobileMenu } = useOutletContext();
  const [days, setDays] = useState(30);
  const { overview, trends, albums, loading, refresh } = useAnalytics(days);
  const { data } = useDashboardContext();

  const busy = loading.overview || loading.trends || loading.albums;

  // Accès Premium (avec période de transition protégée, comme PremiumGate)
  const artist = data?.artist;
  const isPremium = artist?.subscription_tier === 'premium';
  const isGrandfathered = !isPremium && artist?.grandfathered_until && new Date(artist.grandfathered_until) > new Date();
  const hasAccess = isPremium || isGrandfathered;

  return (
    <>
      <DashboardHeader
        title="Analytics"
        subtitle={`Vos statistiques de performance · ${new Date().getFullYear()}`}
        onMenu={toggleMobileMenu}
      />
      <div className="dashboard-content">
      {!hasAccess ? (
        <div className="locked-feature">
          <div className="locked-icon"><i className="fa-solid fa-lock" /></div>
          <span className="content-kicker">Réservé Premium</span>
          <h2>Analytics avancés</h2>
          <p>Les statistiques détaillées (tendances des ventes, performance par album, export CSV) sont réservées aux artistes Premium.</p>
          <div className="locked-list">
            <span><i className="fa-solid fa-check" /> Tendances des ventes</span>
            <span><i className="fa-solid fa-check" /> Performance par album</span>
            <span><i className="fa-solid fa-check" /> Export CSV</span>
          </div>
          <Link to="/dashboard/premium" className="button button-crimson">
            Passer Premium <i className="fa-solid fa-arrow-right" style={{ fontSize: '.7rem' }} />
          </Link>
        </div>
      ) : (
      <>
      <div className="analytics-toolbar">
        <div className="period-switch">
          {[7, 30, 90].map((d) => (
            <button key={d} className={days === d ? 'selected' : ''} onClick={() => setDays(d)}>
              {d} jours
            </button>
          ))}
        </div>
        <button className="button button-soft" onClick={refresh} disabled={busy}>
          Rafraîchir <i className={`fa-solid fa-rotate ${busy ? 'fa-spin' : ''}`} />
        </button>
      </div>

      <div className="analytics-kpis">
        <AnalyticsKPI data={overview} loading={loading.overview} />
      </div>

      <div className="chart-card">
        <TrendsChart data={trends} loading={loading.trends} days={days} />
      </div>

      <div className="albums-performance">
        <AlbumsPerformance data={albums} loading={loading.albums} />
      </div>
      </>
      )}
      </div>
    </>
  );
};

export default Analytics;
